interface DropdownArrowProps {
    showPlus: boolean;
}

const DropdownArrow = ({ showPlus }: DropdownArrowProps) => (
    <span className="relative block h-full w-full">
        <span
            className={`absolute h-full w-px ${
                showPlus ? 'rotate-90' : 'rotate-0'
            } bg-black transition-all duration-layout ease-in-out`}
        />
        <span className="absolute left-0 top-1/2 h-px w-full bg-black" />
    </span>
);

export default DropdownArrow;
